import create, { UseBoundStore } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import { setIn } from "./_utils";
import { createActiveClassroomWindowStore } from "./activeClassroomWindowStore";
import { createActiveZoomStore } from "./activeZoomStore";
import { createChatStore } from "./chatStore";
import { createClassroomStore } from "./classroomStore";
import { createClasswizeConfigStore } from "./classwizeConfigStore";
import { createEventServiceStatusStore } from "./eventServiceStatusStore";
import { createFeatureTogglesStore } from "./featureTogglesStore";
import { createSignatureStore } from "./signatureStore";
import { createClassroomUsersStore, createRestrictedUsersStore, createUsersStore } from "./usersStore";
import { IClassroomStore } from "./classroomStore_I";
import { ISignatureStore } from "./signatureStore_I";
import { IChatStore } from "./chatStore_I";
import { IFeatureTogglesStore } from "@/stores/feaureTogglesStore_I";

export interface ClasswizeState {
	classroom: IClassroomStore;
	signatures: ISignatureStore;
	chat: IChatStore;
	featureToggles: IFeatureTogglesStore;
	activeClassroomWindow: ReturnType<typeof createActiveClassroomWindowStore>;
	zoom: ReturnType<typeof createActiveZoomStore>;
	classwizeConfig: ReturnType<typeof createClasswizeConfigStore>;
}

const useStore: UseBoundStore<ClasswizeState> = create(
	subscribeWithSelector<ClasswizeState>(
		devtools((set, get, api) => ({
			users: createUsersStore(set, get, api, setIn("users", set)),
			restrictedUsers: createRestrictedUsersStore(set, get, api, setIn("restrictedUsers", set)),
			classroomUsers: createClassroomUsersStore(set, get, api, setIn("classroomUsers", set)),
			classwizeConfig: createClasswizeConfigStore(set, get, api, setIn("classwizeConfig", set)),
			featureToggles: createFeatureTogglesStore(set, get, api, setIn("featureToggles", set)) as IFeatureTogglesStore,
			signatures: createSignatureStore(set, get, api, setIn("signatures", set)) as ISignatureStore,
			chat: createChatStore(set, get, api, setIn("chat", set)) as IChatStore,
			eventServiceStatus: createEventServiceStatusStore(set, get, api, setIn("eventServiceStatus", set)),
			activeClassroomWindow: createActiveClassroomWindowStore(set, get, api, setIn("activeClassroomWindow", set)),
			zoom: createActiveZoomStore(set, get, api, setIn("zoom", set)),
			classroom: createClassroomStore(set, get, api, setIn("classroom", set)) as IClassroomStore,
		}))
	)
);

export default useStore;
